// extracted by mini-css-extract-plugin
export var bounce = "_q2-1";
export var generatingText = "_q2-6";
export var lightning = "_q2-4";
export var popup = "_q2-5";
export var progressBar = "_q2-7";
export var progressFill = "_q2-8";
export var progressShimmer = "_q2-9";
export var progressText = "_q2-a";
export var shimmer = "_q2-3";
export var uploadIcon = "_q2-0";
export var uploadingText = "_q2-2";